import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="bg-white my-10">
      <div className="xl:max-w-[1370px] mx-auto px-3">
        <h1 className="text-[#1F488E] md:text-[45px] sm:text-[38px] text-[35px] leading-[126%] text-center mb-3">
          Terms & Conditions
        </h1>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          These Terms and Conditions outline the rules and regulations for the
          use of Glee Biotech Ltd's website. By accessing this website, you
          accept these terms and conditions. Do not continue if you disagree
          with any part of these terms.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          Website Content
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          Glee Biotech provides this website for general informational purposes
          only. We reserve the right to modify, delete, or supplement any
          content without prior notice.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          Accuracy of Information
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          While we strive for accuracy, we do not guarantee the completeness of
          information. We are not liable for any reliance you may place on it.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          No Offer to Contract
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          Nothing on this website should be interpreted as an offer to provide
          any service. Any contract must be formalized in writing.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          User Contributions
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          Any feedback or submissions are treated as non-confidential and may be
          used by Glee Biotech without compensation.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          Warranty and Liability
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          Glee Biotech makes no warranties regarding the availability,
          reliability, or accuracy of this website or its content.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          External Links
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          We are not responsible for content on external websites linked to our
          website.
        </p>
        <h2 className="text-xl font-semibold text-gray-700 mt-6">
          Intellectual Property
        </h2>
        <p className="text-[#59606C] lg:text-[18px] text-[16px] mb-4">
          All content on this website is owned by Glee Biotech or its licensors
          and is protected by copyright and trademark laws.
        </p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
